(function(){
    'use strict'

    angular.module('app.core')
    .factory('AuthInterceptor', AuthInterceptor);

    AuthInterceptor.$inject = ['$injector', '$q', '$location', 'UserInfoService'];

    function AuthInterceptor($injector, $q, $location, UserInfoService) {
        
        var cachedRequest = null;

        var authInterceptor = {  
            request: function (config) {  
                var accessToken = UserInfoService.getToken();  
                if (accessToken == null || accessToken == "undefined") { 
                    $location.path( "/" ); 
                }  
                else {
                    if(!UserInfoService.getCompaniaId()){
                        $location.path( "/seleccionar-compania" );
                    }
                    else{
                        if(config.url.includes('.html') && 
                            !config.url.includes('layout') && 
                            !config.url.includes('widgets') && 
                            !config.url.includes('planillaProcesada.html') && 
                            !config.url.includes('planillaProcesadaDetalle.html'))
                        {
                            $injector.get("BloqueoXUsuarioService").removeAllXUsuario();                            
                        }
                        else if(config.url.includes('planillaProcesada.html') || 
                                config.url.includes('planillaProcesadaDetalle.html'))
                        {
                            UserInfoService.eliminarBloqueosUsuario = true;
                        }
                    }
                    config.headers["Authorization"] = "bearer " + accessToken;
                }  
                return config;  
            },  
  
            requestError: function (config) {  
                $location.path( "/" );   
                return config;  
            },  
  
            response: function (res) {  
                return res;  
            },  
  
            responseError: function (res) {  
                switch (res.status) {
                    case 401:
                        var deferred = $q.defer();
                        if(!cachedRequest){
                            cachedRequest = $injector.get("LoginService").refreshToken(UserInfoService.getRefreshToken(), "refresh_token");
                        }
                        //When Promise is resolved, new Access Token is returend 
                        cachedRequest.then(function(accessToken) {
                            cachedRequest = null;
                            if (accessToken) {
                                UserInfoService.setRefreshTokenInfo(accessToken.data);
                                //Resend this request when Access Token is renewed
                                $injector.get("$http")(res.config).then(function(resp) {
                                    //Resolve this request (successfully this time)
                                    deferred.resolve(resp);
                                },function(resp) {
                                    deferred.reject(resp);
                                });
                            } else {
                                //If any error occurs reject the Promise
                                deferred.reject(res);
                            }
                        }, function(response) {
                            //If any error occurs reject the Promise
                            cachedRequest = null;
                            deferred.reject(response);
                        });
                        return deferred.promise;
                    case 400:
                    case 403:
                    case 404:
                        UserInfoService.userInfo.isAuthenticated = false;
                        $location.path( "/" );
                        break;
                }
                return $q.reject(res);  
            }  
        };  
  
        return authInterceptor;  
    }
})();